import type { Category } from '@cart-ui/CategoryTabs/CategoryTabs'
import { Box } from '@pets-ui/Box/Box'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { ArrowDownLarge, ArrowUpLarge } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useState } from 'react'
import { useStickyOffset } from '../../components/PageLayout/useStickyOffset'

const styles = stylex.create({
  scrollRow: {
    scrollbarWidth: 'none',
    overflowX: 'auto',
  },
})

interface CategoryChipsProps {
  items: Category[]
  value: string
  onChange: (category: Category) => void
}

export const CategoryChips = ({ items, value, onChange }: CategoryChipsProps) => {
  const isMobile = useResponsive('mobile')
  const [isExpanded, setIsExpanded] = useState(false)
  const stickyOffset = useStickyOffset()

  const renderChip = (tab: Category) => {
    const isActive = tab.value === value
    return (
      <Chip
        key={tab.value}
        p={1}
        color={isActive ? 'red' : 'default'}
        selected={isActive}
        isOutlined
        onClick={() => onChange(tab)}
      >
        {tab.label}
      </Chip>
    )
  }

  const renderContent = () => {
    if (!isMobile) {
      return (
        <HStack gap={3} rootStyle={styles.scrollRow}>
          {items.map(renderChip)}
        </HStack>
      )
    }

    if (isExpanded) {
      return (
        <VStack gap={3}>
          <HStack justifyContent="space-between" alignItems="center">
            <Text color={colors.grey600}>請選擇分類</Text>
            <IconButton onClick={() => setIsExpanded(false)} width="30px" height="30px">
              <ArrowUpLarge color={colors.grey600} fontSize={20} />
            </IconButton>
          </HStack>
          <HStack gap={3} flexWrap="wrap">
            {items.map(renderChip)}
          </HStack>
        </VStack>
      )
    }

    return (
      <HStack gap={3} alignItems="center">
        <Box flex="1" rootStyle={styles.scrollRow}>
          <HStack gap={3} flexWrap="nowrap">
            {items.map(renderChip)}
          </HStack>
        </Box>
        <IconButton onClick={() => setIsExpanded(true)} width="30px" height="30px">
          <ArrowDownLarge color={colors.grey600} fontSize={20} />
        </IconButton>
      </HStack>
    )
  }

  return (
    <Box
      position="sticky"
      top={`${stickyOffset}px`}
      zIndex={10}
      backgroundColor={colors.grey100}
      py={2}
    >
      {renderContent()}
    </Box>
  )
}
